import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { formatCurrency } from "../../../../../helpers";
import { useGetInfo } from "../../../../../hooks/useGetInfo";

export const PriceSummary = ({ pOForm = {} }) => {
  const { getStoreInfo } = useGetInfo({ isEnabled: false });
  const storeDetails = getStoreInfo(pOForm?.store_id);
  return (
    <div className={`${globalStyles.cardWithBorder} white`}>
      <h4 className="font-weight-normal">Price Summary</h4>

      <div className="d-flex justify-content-between">
        <p>Total</p>
        <h5 className="purple--text">
          {formatCurrency({
            value: pOForm?.items?.reduce((acc, item) => {
              return (acc +=
                item?.cost_price * Number(item?.requested_quantity));
            }, 0),
            currencyCode: storeDetails?.currency_code,
          })}
        </h5>
      </div>
    </div>
  );
};
